import { action, makeAutoObservable, runInAction } from "mobx";
import { Api } from "../../../common/Api";
import { FilterStore } from "../../FilterStore";

export class BannersStore {
  filterStore: FilterStore;

  loading = false;

  filter: any = {
    page: 0,
    size: 100,
    // keyword: "",
    // period: [undefined, undefined],
  };

  sortedInfo = { columnKey: "createDate", order: "descend" };

  data = {
    total: 0,
    items: [],
  };

  constructor() {
    makeAutoObservable(this, {});
    this.filterStore = new FilterStore(this);
  }

  get pagination() {
    return {
      current: this.filter.page + 1,
      pageSize: this.filter.size,
      total: this.data.total,
    };
  }

  @action onSearch(history) {
    this.onPage(history, 1, this.filter.size);
  }

  @action onPage(history, page, size) {
    const query = new URLSearchParams({ ...this.filter, page: page - 1, size });
    history.push({ search: query.toString() });
  }

  @action onLocation(location) {
    const params = new URLSearchParams(location.search);

    const page = parseInt(params.get("page") || "0");
    const size = parseInt(params.get("size") || "100");
    // const keyword = params.get("keyword") || "";

    this.filter = { page, size };

    this.refresh();
  }

  @action refresh() {
    this.loading = true;

    const { page, size } = this.filter;
    const sorts = this.sortedInfo.order
      ? [{ field: this.sortedInfo.columnKey, order: this.sortedInfo.order === "descend" ? "desc" : "asc" }]
      : [];
    const filter: any = { page, size, sorts };

    return Api.banner
      .banners(filter)
      .then((res) => {
        runInAction(() => {
          this.data = res.data.banners;
        });
      })
      .finally(() => {
        this.loading = false;
      });
  }
}

export const bannersStore = new BannersStore();
